import React, { useState } from 'react';
import {
  FiyatlandirmaKurali, aralikEtiketi, formatTL, minFiyatHesapla,
} from '../utils/fiyatlandirmaKontrol';

interface Props {
  kural: FiyatlandirmaKurali;
  listeFiyati: number | null | undefined;
  ortalamaVade: number;
  onClose: () => void;
}

const formatTarih = (iso: string) => { const [y, m, d] = iso.slice(0, 10).split('-'); return `${d}.${m}.${y}`; };

// Ortalama vade aralıklarına göre satılabilecek en uygun fiyatlar. Fiyatlar müşterinin yanında
// görünmemesi için varsayılan olarak gizlidir; göz ikonuyla açılır.
const FiyatAraliklariModal: React.FC<Props> = ({ kural, listeFiyati, ortalamaVade, onClose }) => {
  const [goster, setGoster] = useState(false);
  const liste = listeFiyati && listeFiyati > 0 ? listeFiyati : null;
  const gizli = '•••••••';

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 10050, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onClose}>
      <div style={{ position: 'absolute', inset: 0, background: 'rgba(15,23,42,0.55)', backdropFilter: 'blur(2px)' }} />
      <div onClick={e => e.stopPropagation()}
        style={{ position: 'relative', width: '94%', maxWidth: 620, maxHeight: '88vh', overflowY: 'auto', background: '#fff', borderRadius: 16, boxShadow: '0 24px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ padding: '16px 22px', borderBottom: '1px solid #f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, color: '#1a2440' }}>
              <i className="fas fa-tags" style={{ color: '#e67d21', marginRight: 8 }}></i>Fiyat Aralıkları
            </div>
            <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>Ortalama vadeye göre satılabilecek en uygun fiyatlar</div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <button type="button" onClick={() => setGoster(g => !g)} title={goster ? 'Fiyatları gizle' : 'Fiyatları göster'}
              style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '7px 12px', border: '1px solid #e2e8f0', borderRadius: 8, background: goster ? '#fff7ed' : '#fff', color: '#92400e', fontSize: 12.5, fontWeight: 600, cursor: 'pointer' }}>
              <i className={`fas ${goster ? 'fa-eye-slash' : 'fa-eye'}`}></i>{goster ? 'Gizle' : 'Göster'}
            </button>
            <button type="button" onClick={onClose}
              style={{ width: 32, height: 32, border: 'none', borderRadius: '50%', background: '#f1f5f9', color: '#475569', cursor: 'pointer', fontSize: 16 }}>×</button>
          </div>
        </div>

        <div style={{ padding: '16px 22px', display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            {[
              { lbl: 'Liste Fiyatı', val: liste ? (goster ? formatTL(liste) : gizli) : '—' },
              { lbl: 'Planın Ortalama Vadesi', val: `${ortalamaVade} gün` },
              { lbl: 'En Fazla Ortalama Vade', val: kural.maksOrtalamaVadeGun != null ? `${kural.maksOrtalamaVadeGun} gün` : '—' },
              { lbl: 'Son Ödeme Tarihi', val: kural.sonOdemeTarihi ? formatTarih(kural.sonOdemeTarihi) : '—' },
            ].map(x => (
              <div key={x.lbl} style={{ flex: '1 1 120px', background: '#f8fafc', border: '1px solid #eef2f7', borderRadius: 10, padding: '9px 12px' }}>
                <div style={{ fontSize: 10.5, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{x.lbl}</div>
                <div style={{ fontSize: 14, fontWeight: 700, color: '#1a2440', marginTop: 3 }}>{x.val}</div>
              </div>
            ))}
          </div>

          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#f8fafc' }}>
                {['Ortalama Vade', 'En Fazla İndirim', 'En Uygun Satış Fiyatı'].map(h => (
                  <th key={h} style={{ padding: '9px 12px', textAlign: 'left', fontSize: 10.5, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', borderBottom: '1px solid #eef2f7' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {kural.araliklar.map(a => {
                const aktifAralik = ortalamaVade >= a.baslangicGun && ortalamaVade <= a.bitisGun;
                return (
                  <tr key={a.baslangicGun} style={{ background: aktifAralik ? '#fff7ed' : '#fff', borderBottom: '1px solid #f1f5f9' }}>
                    <td style={{ padding: '9px 12px', fontWeight: 600, color: '#1a2440' }}>
                      {aralikEtiketi(a)}
                      {aktifAralik && <span style={{ marginLeft: 8, fontSize: 10.5, fontWeight: 700, color: '#c2410c', background: '#ffedd5', padding: '2px 7px', borderRadius: 20 }}>Bu plan</span>}
                    </td>
                    <td style={{ padding: '9px 12px', color: '#475569' }}>%{a.maksIndirimOrani}</td>
                    <td style={{ padding: '9px 12px', fontWeight: 700, color: '#059669', letterSpacing: goster ? 0 : 2 }}>
                      {liste ? (goster ? formatTL(minFiyatHesapla(liste, a.maksIndirimOrani)) : gizli) : '—'}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {!liste && <div style={{ fontSize: 12, color: '#b45309' }}>Liste fiyatı tanımlı olmadığı için tutarlar hesaplanamıyor; yalnızca indirim oranları gösteriliyor.</div>}
          {kural.yoneticiKuralDisiCikabilir && kural.yoneticiler.length > 0 && (
            <div style={{ fontSize: 12, color: '#64748b' }}>
              Proje yöneticileri ({kural.yoneticiler.map(y => y.adSoyad).join(', ')}) bu kuralların dışına çıkabilir.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FiyatAraliklariModal;
